// extracted by mini-css-extract-plugin
module.exports = {"leftSidebar":"demo_leftSidebar__2ngo9"};